import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../src/fonts/Breathing Font/Breathing.ttf';
import '../src/fonts/Breathing Font/Breathing.otf';
import './pwa.css'; // PWA standalone mode styling

// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext/AuthContext';
import { TestModeProvider } from './contexts/TestModeContext';
import { LessonSessionProvider } from './contexts/LessonSessionContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<HelmetProvider>
			<Router>
				<AuthProvider>
					<TestModeProvider>
						<LessonSessionProvider>
							<App />
						</LessonSessionProvider>
					</TestModeProvider>
				</AuthProvider>
			</Router>
		</HelmetProvider>
	</React.StrictMode>
);

// Service worker retired. The old cache-first SW (public/service-worker.js,
// cache "cyv-portal-v1") served a stale app shell and caused post-deploy blank
// screens. We no longer register a service worker for new visitors, and we
// actively unregister any existing one for clients that still have it.
// public/service-worker.js is now a kill-switch that also clears caches.
serviceWorkerRegistration.unregister();
